import { library } from '@fortawesome/fontawesome-svg-core/index'
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle'
import { faExclamationTriangle as faExclamationTriangleLight } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle'
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle'
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle'
import { faClock } from '@fortawesome/pro-solid-svg-icons/faClock'
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle'
import { faTimesCircle as faTimesCircleLight } from '@fortawesome/pro-light-svg-icons/faTimesCircle'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft'

library.add([
  faExclamationTriangle,
  faPlusCircle,
  faQuestionCircle,
  faClock,
  faTimesCircle,
  faTimesCircleLight,
  faCheckCircle,
  faInfoCircle,
  faArrowRight,
  faExclamationTriangleLight,
  faArrowLeft,
])
